import React from "react";

import { Container, Row, Col, Form, Button } from "react-bootstrap";
import Select from "react-select";

import { useProfilePageContext } from "../lib/context";
import { useFormHandlers } from "../hooks/useFormHandlers";
import "../../../../assets/css/umphub/pages/profile.scss";
import { displayFormAlert } from "../../../../lib/utils";
import { Controller } from "react-hook-form";

const ProfileForm = (): React.JSX.Element => {
    const { formMethods } = useProfilePageContext();
    const {
        handleSubmit,
        register,
        control,
        formState: { errors },
    } = formMethods;
    const { onSubmit, onError } = useFormHandlers();

    return (
        <div data-testid="profileContent">
            <Container className="py-3 profile">
                <Row>
                    <Col md={8}>
                        <Form
                            onSubmit={handleSubmit(onSubmit, onError)}
                            id="profileForm"
                        >
                            <Row>
                                <Col>
                                    <h2>Edit Account</h2>
                                    <p>
                                        <b>Note:</b> All fields are required
                                    </p>
                                </Col>
                            </Row>
                            {/* //! if admin, select user to edit */}
                            <Row>
                                <Form.Label>Name *</Form.Label>
                                <Form.Group as={Col} controlId="firstName">
                                    <Form.Control
                                        type="text"
                                        {...register("firstName")}
                                        aria-invalid={
                                            errors.firstName ? "true" : "false"
                                        }
                                    />
                                    <Form.Label>First</Form.Label>
                                    {errors.firstName &&
                                        displayFormAlert({
                                            level: "danger",
                                            text: errors.firstName
                                                .message as string,
                                        })}
                                </Form.Group>
                                <Form.Group as={Col} controlId="lastName">
                                    <Form.Control
                                        type="text"
                                        {...register("lastName")}
                                        aria-invalid={
                                            errors.lastName ? "true" : "false"
                                        }
                                    />
                                    <Form.Label>Last</Form.Label>
                                    {errors.lastName &&
                                        displayFormAlert({
                                            level: "danger",
                                            text: errors.lastName
                                                .message as string,
                                        })}
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Label>Address *</Form.Label>
                                <Form.Group as={Col} controlId="address">
                                    <Form.Control
                                        type="text"
                                        {...register("address")}
                                        aria-invalid={
                                            errors.address ? "true" : "false"
                                        }
                                    />
                                    <Form.Label>Street Address</Form.Label>
                                    {errors.address &&
                                        displayFormAlert({
                                            level: "danger",
                                            text: errors.address
                                                .message as string,
                                        })}
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group as={Col} controlId="address2">
                                    <Form.Control
                                        type="text"
                                        {...register("address2")}
                                        aria-invalid={
                                            errors.address2 ? "true" : "false"
                                        }
                                    />
                                    <Form.Label>Address Line 2</Form.Label>
                                    {errors.address2 &&
                                        displayFormAlert({
                                            level: "danger",
                                            text: errors.address2
                                                .message as string,
                                        })}
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group as={Col} controlId="city">
                                    <Form.Control
                                        type="text"
                                        {...register("city")}
                                        aria-invalid={
                                            errors.city ? "true" : "false"
                                        }
                                    />
                                    <Form.Label>City</Form.Label>
                                    {errors.city &&
                                        displayFormAlert({
                                            level: "danger",
                                            text: errors.city.message as string,
                                        })}
                                </Form.Group>
                                <Form.Group as={Col} xs={2} controlId="state">
                                    <Form.Control
                                        type="text"
                                        {...register("state")}
                                        aria-invalid={
                                            errors.state ? "true" : "false"
                                        }
                                    />
                                    <Form.Label>State</Form.Label>
                                    {errors.state &&
                                        displayFormAlert({
                                            level: "danger",
                                            text: errors.state
                                                .message as string,
                                        })}
                                </Form.Group>
                                <Form.Group as={Col} xs={4} controlId="zipCode">
                                    <Form.Control
                                        type="text"
                                        {...register("zipCode")}
                                        aria-invalid={
                                            errors.zipCode ? "true" : "false"
                                        }
                                    />
                                    <Form.Label>Zip Code</Form.Label>
                                    {errors.zipCode &&
                                        displayFormAlert({
                                            level: "danger",
                                            text: errors.zipCode
                                                .message as string,
                                        })}
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group as={Col} xs={4} controlId="phone">
                                    <Form.Label>Phone *</Form.Label>
                                    <Form.Control
                                        type="text"
                                        {...register("phone")}
                                        aria-invalid={
                                            errors.phone ? "true" : "false"
                                        }
                                    />
                                    <Form.Label>Phone</Form.Label>
                                    {errors.phone &&
                                        displayFormAlert({
                                            level: "danger",
                                            text: errors.phone
                                                .message as string,
                                        })}
                                </Form.Group>
                                <Form.Group as={Col} xs={4} controlId="dob">
                                    <Form.Label>Date of Birth *</Form.Label>
                                    <Form.Control
                                        type="text"
                                        {...register("dob")}
                                        placeholder="mm/dd/yyyy"
                                        aria-invalid={
                                            errors.dob ? "true" : "false"
                                        }
                                    />
                                    {errors.dob &&
                                        displayFormAlert({
                                            level: "danger",
                                            text: errors.dob.message as string,
                                        })}
                                </Form.Group>
                                <Form.Group controlId="ssn" as={Col} xs={4}>
                                    <Form.Label>SSN *</Form.Label>
                                    <Form.Control
                                        {...register("ssn")}
                                        type="text"
                                        maxLength={11}
                                        aria-invalid={
                                            errors.ssn ? "true" : "false"
                                        }
                                    />
                                    <Form.Label>
                                        I certify my SSN is correct, I am not
                                        subject to backup withholding and am a
                                        US Person.
                                    </Form.Label>
                                    {errors.ssn &&
                                        displayFormAlert({
                                            level: "danger",
                                            text: errors.ssn.message as string,
                                        })}
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group as={Col} xs={3} controlId="race">
                                    <Form.Label>Race *</Form.Label>
                                    <Controller
                                        name="race"
                                        control={control}
                                        rules={{
                                            required: "Race is required",
                                        }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                isSearchable={false}
                                                options={[
                                                    "White",
                                                    "Black",
                                                    "Hispanic",
                                                    "Other",
                                                ].map(r => {
                                                    return {
                                                        value: r,
                                                        label: r,
                                                    };
                                                })}
                                            />
                                        )}
                                    />
                                    {errors.race &&
                                        displayFormAlert({
                                            level: "danger",
                                            text: errors.race.value
                                                ?.message as string,
                                        })}
                                </Form.Group>
                                <Form.Group as={Col} xs={3} controlId="gender">
                                    <Form.Label>Gender *</Form.Label>
                                    <Controller
                                        name="gender"
                                        control={control}
                                        rules={{
                                            required: "Gender is required",
                                        }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                isSearchable={false}
                                                options={["Male", "Female"].map(
                                                    r => {
                                                        return {
                                                            value: r,
                                                            label: r,
                                                        };
                                                    },
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.gender &&
                                        displayFormAlert({
                                            level: "danger",
                                            text: errors.gender.value
                                                ?.message as string,
                                        })}
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Label>Email *</Form.Label>
                                <Form.Group as={Col} controlId="email">
                                    <Form.Control
                                        type="email"
                                        {...register("email")}
                                        aria-invalid={
                                            errors.email ? "true" : "false"
                                        }
                                    />
                                    <Form.Label>Enter Email</Form.Label>
                                    {errors.email &&
                                        displayFormAlert({
                                            level: "danger",
                                            text: errors.email
                                                .message as string,
                                        })}
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Label>Password *</Form.Label>
                                <Form.Group as={Col} controlId="password">
                                    <Form.Control
                                        type="password"
                                        {...register("password")}
                                        aria-invalid={
                                            errors.password ? "true" : "false"
                                        }
                                    />
                                    <Form.Label>Enter Password</Form.Label>
                                    {errors.password &&
                                        displayFormAlert({
                                            level: "danger",
                                            text: errors.password
                                                .message as string,
                                        })}
                                </Form.Group>
                                <Form.Group
                                    as={Col}
                                    controlId="confirmPassword"
                                >
                                    <Form.Control
                                        type="password"
                                        {...register("confirmPassword")}
                                        aria-invalid={
                                            errors.confirmPassword
                                                ? "true"
                                                : "false"
                                        }
                                    />
                                    <Form.Label>Confirm Password</Form.Label>
                                    {errors.confirmPassword &&
                                        displayFormAlert({
                                            level: "danger",
                                            text: errors.confirmPassword
                                                .message as string,
                                        })}
                                </Form.Group>
                                <Form.Text>
                                    (Password will not be changed if left blank)
                                </Form.Text>
                            </Row>
                            <Row>
                                <Col>
                                    <Button variant="primary" type="submit">
                                        Submit
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ProfileForm;
